import React, { useEffect, useState } from 'react'
import Header from './Layouts/Header'
import Sidebar from './Layouts/Sidebar';
import { SERVER_URL } from '../Config';
import axios from 'axios';
import toast from 'react-hot-toast';

const networkIcons = {
  TRON: 'https://cdn3d.iconscout.com/3d/premium/thumb/tron-trx-badge-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--cryptocurrency-symbol-crypto-badges-vol-1-pack-science-technology-illustrations-4414723.png?f=webp',
  BNB: 'https://cdn3d.iconscout.com/3d/premium/thumb/binance-crypto-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--symbol-sign-logo-coin-glossy-pack-science-technology-illustrations-3591027.png?f=webp',
  ETH: '/assets/img/icon/watch-icon-07.svg',
  POL: 'https://cryptologos.cc/logos/polygon-matic-logo.png',
  SOL: 'https://cdn-icons-png.flaticon.com/512/6001/6001527.png'
};

function StakeTrans() {

  const [transactions, setTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalTransactions, setTotalTransactions] = useState(0);

  useEffect(() => {
    axios.get(`${SERVER_URL}/api/admin/stakeTransactions`)
      .then(response => {
        if (response.data.status) {
          setTransactions(response.data.transactions);
          setTotalTransactions(response.data.totalTransactions); 
          console.log(response.data.transactions);
        }
      })
      .catch(error => console.error('Error fetching transactions:', error));
  }, []);

  const filteredTransactions = transactions.filter((tx) =>
    Object.values(tx).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  function formatDate(dateString) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year} -${month} -${day} ${hours}:${minutes}:${seconds}`;
  }

  const shortenHash = (hash) => {
    return hash ? `${hash.slice(0, 6)}...${hash.slice(-6)}` : "";
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("Copied to clipboard!"); // Optional: Show a message when copied
    });
  };

  const getExplorerLink = (network, hash) => {
    const explorers = {
      BNB: `https://bscscan.com/tx/${hash}`,
      ETH: `https://etherscan.io/tx/${hash}`,
      POL: `https://polygonscan.com/tx/${hash}`,
      TRON: `https://tronscan.org/#/transaction/${hash}`,
    };

    return explorers[network] || "#"; // Default to "#" if network is unknown
  };


  return (
    <div>
      <>
        <Header />
        <Sidebar />
        <div className="page-wrapper bg-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-sm-12">
                <div className="transaction-grp">
                  <div className="row">
                    <div className="col-xl-3 col-md-6">
                      <div className="transaction-record blue-view">
                      <h2>{totalTransactions}</h2> 
                        <p>Total Transactions</p>
                      </div>
                    </div>
                    {/* <div className="col-xl-3 col-md-6">
                      <div className="transaction-record red-view">
                        <h2>5648</h2>
                        <p>Transactions per hour</p>
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                      <div className="transaction-record green-view">
                        <h2>5648</h2>
                        <p>Largest Transactions</p>
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                      <div className="transaction-record black-view">
                        <h2>5648</h2>
                        <p>Total Received</p>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="recent-buy comman-head">
                  <h3>Recent transactions</h3>
                  {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                  <div className="row">
                    <div className="col-md-12">
                      <div className="buy-form-crypto mb-0">
                        {/* <div className="border-watch mb-2">
                    <div className="row">
                      <div className="col-xl-9  d-flex align-items-center">
                        <div className="status-blk">
                          <div className="row">
                            <div className="col-lg-2">
                              <div className="action-head">
                                <h4>Latest actions </h4>
                                <span>(Showing 01 to 06 of 100)</span>
                              </div>
                            </div>
                            <div className="col-lg-3 d-flex align-items-center">
                              <div className="form-group date-border cal-icon">
                                <input
                                  type="text"
                                  className="form-control datetimepicker"
                                  placeholder="DD-MM-YYYY"
                                />
                              </div>
                            </div>
                            <div className="col-lg-3 d-flex align-items-center">
                              <div className="form-group date-border cal-icon">
                                <input
                                  type="text"
                                  className="form-control datetimepicker"
                                  placeholder="DD-MM-YYYY"
                                />
                              </div>
                            </div>
                            <div className="col-lg-2 d-flex align-items-center">
                              <div className="form-group bg-hover date-border">
                                <select className="form-control select">
                                  <option>$Currency type</option>
                                  <option>Credit</option>
                                  <option>Debit </option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-2 d-flex align-items-center">
                              <div className="form-group bg-hover date-border">
                                <select className="form-control select">
                                  <option>Type</option>
                                  <option>Buy</option>
                                  <option>Sell</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 d-flex align-items-center">
                        <label className="me-2">SortBy:</label>
                        <div className="form-group date-border sort-by cal-icon me-2">
                          <input
                            type="text"
                            className="form-control datetimepicker"
                            placeholder="DD-MM-YYYY"
                          />
                        </div>
                        <div className="down-range date-border">
                          <a href="javascript:;">
                            <img src="/assets/img/icon/down-icon.svg" alt="" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div> */}
                        <input
                          type="text"
                          placeholder="Search transactions..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="form-control mb-3"
                        />
                        <div className="table-responsive">
                          <table className="datatable table  custom-table">
                            <thead>
                              <tr>
                                <th>ID No</th>
                                <th>Currency type</th>
                                <th style={{ minWidth: 110 }}>Wallet Address</th>
                                <th style={{ minWidth: 110 }}>Amount</th>
                                <th style={{ minWidth: 110 }}>Stake Hash</th>
                                <th style={{ minWidth: 110 }}>Withdraw Hash</th>
                                <th style={{ minWidth: 110 }}>Reward Amount</th>
                                <th style={{ minWidth: 110 }}>Date</th>
                                <th style={{ minWidth: 90 }}>Status</th>
                              </tr>
                            </thead>
                            {/* <tbody>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td>
                            <img
                              src="/assets/img/icon/watch-icon-07.svg"
                              alt="Award"
                              className="me-2"
                            />
                            Ethereum
                          </td>
                          <td>
                            <span className="custom-badge status-green">
                              <i
                                className="fas fa-arrow-up"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td>0.568</td>
                          <td>$ 11,723.40</td>
                          <td>979.28</td>
                          <td>0.2</td>
                          <td>05:30 AM</td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="transactions.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td>
                            <img
                              src="/assets/img/icon/watch-icon-01.svg"
                              alt="Award"
                              className="me-2"
                            />
                            Ripple{" "}
                          </td>
                          <td>
                            <span className="custom-badge status-red">
                              <i
                                className="fas fa-arrow-down"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td>0.568</td>
                          <td>$ 11,723.40</td>
                          <td>979.28</td>
                          <td>0.2</td>
                          <td>05:30 AM</td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="transactions.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td>
                            <img
                              src="/assets/img/icon/watch-icon-02.svg"
                              alt="Award"
                              className="me-2"
                            />
                            Cardeno
                          </td>
                          <td>
                            <span className="custom-badge status-red">
                              <i
                                className="fas fa-arrow-down"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td>0.568</td>
                          <td>$ 11,723.40</td>
                          <td>979.28</td>
                          <td>0.2</td>
                          <td>05:30 AM</td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="transactions.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td>
                            <img
                              src="/assets/img/icon/watch-icon-03.svg"
                              alt="Award"
                              className="me-2"
                            />
                            NEO{" "}
                          </td>
                          <td>
                            <span className="custom-badge status-red">
                              <i
                                className="fas fa-arrow-down"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td>0.568</td>
                          <td>$ 11,723.40</td>
                          <td>979.28</td>
                          <td>0.2</td>
                          <td>05:30 AM</td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="transactions.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <a href="javascript:;">#4562665</a>
                          </td>
                          <td>
                            <img
                              src="/assets/img/icon/watch-icon-08.svg"
                              alt="Award"
                              className="me-2"
                            />
                            BTC{" "}
                          </td>
                          <td>
                            <span className="custom-badge status-red">
                              <i
                                className="fas fa-arrow-down"
                                aria-hidden="true"
                              />{" "}
                              263.54 %
                            </span>
                          </td>
                          <td>0.568</td>
                          <td>$ 11,723.40</td>
                          <td>979.28</td>
                          <td>0.2</td>
                          <td>05:30 AM</td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a
                                href="transactions.html#"
                                className="action-icon dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="feather-more-vertical" />
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{}}
                              >
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                >
                                  <i className="fas fa-pencil-alt m-r-5" /> Edit
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="javascript:;"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fas fa-trash-alt m-r-5" />{" "}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody> */}

                            <tbody>
                              {filteredTransactions.length > 0 ? (
                                filteredTransactions.map((tx, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <img
                                        src={networkIcons[tx.network] || '/assets/img/icon/dash-icon-02.svg'}
                                        alt={tx.network}
                                        className="me-2"
                                        width="24"
                                        height="24"
                                      />
                                      {tx.network}
                                    </td>
                                    <td onClick={() => copyToClipboard(tx.wallet_address)} className="cursor-pointer">{tx.wallet_address}</td>
                                    <td>{tx.amount}</td>
                                    <td>
                                      <a
                                        href={getExplorerLink(tx.network, tx.stake_hash)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-500 hover:underline"
                                      >
                                        {shortenHash(tx.stake_hash)}
                                      </a>
                                    </td>
                                    <td onClick={() => copyToClipboard(tx.withdraw_hash)} className="cursor-pointer">
                                      {shortenHash(tx.withdraw_hash)}
                                    </td>
                                    <td>{tx.rewardAmount}</td>
                                    <td>{formatDate(tx.created_at)}</td>
                                    <td>
                                      <span className={`custom-badge ${tx.stake_status === 'success' ? 'status-green' : tx.stake_status === 'pending' ? 'status-yellow' : 'status-red'}`}>
                                        {tx.stake_status}
                                      </span>
                                    </td>

                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="9" className="text-center">No Transactions Found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="notification-box">
          <div className="msg-sidebar notifications msg-noti">
            <div className="topnav-dropdown-header">
              <span>Messages</span>
            </div>
            <div className="drop-scroll msg-list-scroll" id="msg_list">
              <ul className="list-box">
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">R</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Richard Miles </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item new-message">
                      <div className="list-left">
                        <span className="avatar">J</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">John Doe</span>
                        <span className="message-time">1 Aug</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">T</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author"> Tarah Shropshire </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">M</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Mike Litorus</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">C</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author"> Catherine Manseau </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">D</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author"> Domenic Houston </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">B</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author"> Buster Wigton </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">R</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author"> Rolland Webber </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">C</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author"> Claire Mapes </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">M</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Melita Faucher</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">J</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Jeffery Lalor</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">L</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Loren Gatlin</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="chat.html">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">T</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Tarah Shropshire</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div className="topnav-dropdown-footer">
              <a href="chat.html">See all messages</a>
            </div>
          </div>
        </div> */}
      </>

    </div>
  )
}

export default StakeTrans